import { Map, List } from 'immutable';
import { SUCCESS, ERROR } from '../actions/utils';
import * as actions from '../actions/global';
import * as toastActions from '../actions/toast';

function pushError (state, error, entity) {
  return state.push(Map({ type: 'error', error, entity }));
}

function pushSuccess (state, message) {
  return state.push(Map({ type: 'success', message }));
}

function pop (state) {
  return state.shift();
}

export default (state = List(), action) => {
  switch (action.type) {
    case actions.SEARCH_CONFIG_FETCH_ERROR:
      return pushError(state, action.error, 'Fetching Search Config');
    case actions.SEARCH_RESULT_CONFIG_FETCH_ERROR:
      return pushError(state, action.error, 'Fetching Search Result Config');
    case actions.SEARCH_ERROR:
      return pushError(state, action.error, 'Searching Properties');
    case actions.PROPERTY_FETCH_ERROR:
      return pushError(state, action.error, 'Fetching Property Detail');
    case actions.HEARING_OPEN_ERROR:
      return pushError(state, action.error, 'Opening Hearing Notice');
    case actions.TAXING_UNIT_FETCH_ERROR:
      return pushError(state, action.error, 'Fetching Taxing Unit');
    case actions.ADOPTED_PDF_FETCH_ERROR:
      return pushError(state, action.error, 'Fetching Adopted Pdf');
    case actions.ETR_PDF_FETCH_ERROR:
      return pushError(state, action.error, 'Fetching ETR Pdf');
    case actions.BUDGET_PDF_FETCH_ERROR:
      return pushError(state, action.error, 'Fetching Budget Pdf');
    case actions.TOKEN_FETCH_ERROR:
      return pushError(state, action.error, 'Fetching new token');
    case actions.CREATE_TAXING_UNIT_MESSAGE[SUCCESS]:
      return pushSuccess(state, 'Message Sent');
    case actions.CREATE_TAXING_UNIT_MESSAGE[ERROR]:
      return pushError(state, action.error, 'Sending Message');
    case toastActions.SHOW_MESSAGE:
      return pushError(state, action.error, action.payload.entity);
    case toastActions.TOAST_POP:
      return pop(state);

    default:
      return state;
  }
};
